export default class Score {
  key?: string | null;
  km?: number;
  first?: string;
  second?: string;
  third?: string;
}